import { schema } from 'normalizr';

import * as PART from '../part';

export const quoteItemAddOnCell = new schema.Entity('quoteItemAddOnCells');
export const quoteItemAddOnCells = [quoteItemAddOnCell];

export const quoteItemAddOn = new schema.Entity('quoteItemAddOns', {
  addOnCells: quoteItemAddOnCells, //HACK: WHEN CREATING AN ADD-ON WE RETURN AN ADD-On WITH ADD-ON CELLS BUT ORDINARILY WE DONT
});
export const quoteItemAddOns = [quoteItemAddOn];

export const quoteItemProfitItemCell = new schema.Entity(
  'quoteItemProfitItemCells',
);
export const quoteItemProfitItemCells = [quoteItemProfitItemCell];

export const quoteItemProfitItem = new schema.Entity('quoteItemProfitItems', {
  profitItemCells: quoteItemProfitItemCells, //HACK: WHEN CREATING AN ADD-ON WE RETURN AN ADD-On WITH ADD-ON CELLS BUT ORDINARILY WE DONT
});
export const quoteItemProfitItems = [quoteItemProfitItem];

export const quoteItemDiscountCell = new schema.Entity(
  'quoteItemDiscountCells',
);
export const quoteItemDiscountCells = [quoteItemDiscountCell];

export const quoteItemDiscount = new schema.Entity('quoteItemDiscounts', {
  discountCells: quoteItemDiscountCells, //HACK: WHEN CREATING AN ADD-ON WE RETURN AN ADD-On WITH ADD-ON CELLS BUT ORDINARILY WE DONT
});
export const quoteItemDiscounts = [quoteItemDiscount];

export const quoteItemExpedite = new schema.Entity('quoteItemExpedites');
export const quoteItemExpedites = [quoteItemExpedite];

export const quoteItemCell = new schema.Entity('quoteItemCells');
export const quoteItemCells = [quoteItemCell];

export const quoteItemQuantity = new schema.Entity('quoteItemQuantities', {
  addOnCells: quoteItemAddOnCells,
  discountCells: quoteItemDiscountCells,
  profitItemCells: quoteItemProfitItemCells,
  cells: quoteItemCells,
  expedites: quoteItemExpedites,
});
export const quoteItemQuantities = [quoteItemQuantity];

export const quoteItemOperation = new schema.Entity('quoteItemOperations', {
  cells: quoteItemCells, //HACK: WHEN CREATING AN OPERATION WE RETURN AN OPERATION WITH CELLS BUT ORDINARILY WE DONT
});
export const quoteItemOperations = [quoteItemOperation];

export const quoteItemBriefComponent = new schema.Entity(
  'quoteItemBriefComponents',
);
export const quoteItemBriefComponents = [quoteItemBriefComponent];

export const quoteItemComponent = new schema.Entity('quoteItemComponents', {
  addOns: quoteItemAddOns,
  addOnCells: quoteItemAddOnCells,
  profitItems: quoteItemProfitItems,
  profitItemCells: quoteItemProfitItemCells,
  discounts: quoteItemDiscounts,
  discountCells: quoteItemDiscountCells,
  cells: quoteItemCells,
  operations: quoteItemOperations,
  part: PART.schema.part,
  quantities: quoteItemQuantities,
});

export const quoteItem = new schema.Entity('quoteItems', {
  rootComponent: quoteItemComponent,
});

export const quoteItems = [quoteItem];
